import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";

export default function MyCollapse({ heading, children }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      <button
        type="button"
        className="btn p-0 w-100 text-start text-nowrap"
        onClick={() => {
          setShow((p) => !p);
        }}
      >
        <div className="d-flex">
          {heading}
          <span className="bg-icon p-1 px-2 ms-2 rounded-2 text-purple d-inline-block">
            {show ? (
              <FontAwesomeIcon icon={faAngleUp} />
            ) : (
              <FontAwesomeIcon icon={faAngleDown} />
            )}
          </span>
        </div>
      </button>
      <Collapse in={show}>
        <div>{children}</div>
      </Collapse>
    </div>
  );
}
